// Arabic Products index — mirrors the English ProductsIndex.
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Seo } from "@/components/Seo";
import { ArPageHero, ArBlock, ArContactCTA } from "@/pages/ar/_ArShared";

export default function ProductsIndexAr() {
  const twasalUrl = (process.env.REACT_APP_TWASAL_URL || "").trim();
  const products = [
    { title: "Meyar", desc: "حوكمة المؤسسات وحوكمة الأمن السيبراني.", to: "/ar/meyar" },
    { title: "منصة التوصيل والخدمات اللوجستية", desc: "تطبيقات للعميل، السائق، الإدارة، والشاحن.", to: "/ar/solutions/on-demand-delivery-platform" },
    { title: "نظام إدارة المستودعات", desc: "من الاستلام إلى الإرسال، بدقة على مستوى الصندوق.", to: "/ar/solutions/warehouse-management" },
    { title: "إدارة المعارض", desc: "مخزون المركبات، المبيعات، والمستندات.", to: "/ar/solutions/showroom-management" },
    { title: "منصة تجارة السوق الإلكتروني", desc: "متعدد البائعين، طلبات مقسّمة، وتحويلات.", to: "/ar/solutions/e-commerce-marketplace" },
  ];
  return (
    <div data-testid="products-index-ar">
      <Seo title="المنتجات — وفا سوليوشنز" description="برمجيات نملكها، تعمل في الإنتاج. والمزيد قيد التطوير." />
      <ArPageHero
        eyebrow="المنتجات"
        h1="برمجيات نملكها، تعمل في الإنتاج"
        sub="هذه ملكنا — صممناها، بنيناها، وندعمها. لذلك عندما ننصحكم ببنية أو تسعير، يأتي ذلك من تشغيل منصة حيّة فعليًا، لا من القراءة عنها. والمزيد قيد التطوير."
        breadcrumbs={[{ label: "الرئيسية", to: "/ar" }, { label: "المنتجات" }]}
      />

      <ArBlock tint="white">
        <div className="mb-2 text-xs font-semibold uppercase tracking-widest text-wafa-primary">
          نحن شركة منتجات بقدر ما نحن شركة خدمات.
        </div>
        <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          {products.map((p) => (
            <Link
              key={p.to}
              to={p.to}
              data-testid={`product-ar-${p.title.replace(/[^a-zA-Z0-9]+/g, "-")}`}
              className="group flex flex-col rounded-lg border border-wafa-deep/10 bg-white p-6 transition-all duration-200 hover:-translate-y-1 hover:border-wafa-deep/25"
            >
              <div className="font-heading text-lg font-semibold text-wafa-deep group-hover:text-wafa-primary">{p.title}</div>
              <p className="mt-3 text-sm text-wafa-ink/70">{p.desc}</p>
            </Link>
          ))}
          {twasalUrl ? (
            <a
              href={twasalUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="product-ar-twasal-awasal"
              className="group flex flex-col rounded-lg border border-wafa-deep/10 bg-white p-6 transition-all duration-200 hover:-translate-y-1 hover:border-wafa-deep/25"
            >
              <div className="flex items-center justify-between">
                <div className="font-heading text-lg font-semibold text-wafa-deep group-hover:text-wafa-primary">Twasal Awasal</div>
                <ArrowRight className="h-4 w-4 -rotate-45 text-wafa-primary" />
              </div>
              <p className="mt-3 text-sm text-wafa-ink/70">توصيل متعدد الخدمات لعُمان، بالشراكة مع AlAwal Cargo Services. يُطلق على موقعه الخاص.</p>
            </a>
          ) : (
            <div data-testid="product-ar-twasal-awasal" className="flex flex-col rounded-lg border border-dashed border-wafa-deep/20 bg-wafa-cream/40 p-6">
              <div className="font-heading text-lg font-semibold text-wafa-deep">Twasal Awasal</div>
              <p className="mt-3 text-sm text-wafa-ink/70">توصيل متعدد الخدمات لعُمان، بالشراكة مع AlAwal Cargo Services. جاهز للإطلاق — للمنصة موقعها الخاص المستقل.</p>
            </div>
          )}
          <div className="flex flex-col items-start justify-center rounded-lg border border-dashed border-wafa-deep/25 bg-wafa-cream/40 p-6">
            <div className="font-heading text-lg font-semibold text-wafa-deep">والمزيد قيد التطوير.</div>
            <p className="mt-3 text-sm text-wafa-ink/70">خط الأنابيب لا يتوقف. تواصلوا معنا إن أردتم معرفة ما هو التالي.</p>
          </div>
        </div>
      </ArBlock>

      <ArContactCTA heading="تودّون عرضًا تجريبيًا؟" />
    </div>
  );
}
